/* global window */
import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import './sliderVideo.scss'

export const OVERLAY_CLASS = 'overlay'
const VIDEO_CONTAINER_CLASS = 'video-container'

const SliderVideo = ({ video, title = '' }) => {
  const [play, setPlay] = useState(false)
  const innerRef = useRef(null)

  useEffect(() => {
    const mouseDownHandler = (e) => {
      e.stopPropagation()
      const inner = innerRef.current

      if (inner &&
        inner.childNodes &&
        'contains' in e.target &&
        e.target.contains(inner)
      ) {
        setPlay(true)
      }
    }

    window.addEventListener('mousedown', mouseDownHandler)

    const timer = setTimeout(() => {
      const inner = innerRef.current
      if (inner) {
        $(inner).closest('.swiper-wrapper').find('.swiper-slide:first-child .slide-content').removeClass(OVERLAY_CLASS)
        $(inner).closest('.slider-component').addClass('slider-component--video')
      }
    }, 1000)

    return () => {
      window.removeEventListener('mousedown', mouseDownHandler)
      clearTimeout(timer)
    }
  }, [])

  return (
    <div className="iframe-container">
      <iframe
        ref={innerRef}
        className={VIDEO_CONTAINER_CLASS}
        src={video}
        allowFullScreen
        title={title}
        allowvr="yes"
      />
    </div>
  )
}

SliderVideo.propTypes = {
  video: PropTypes.string.isRequired,
  title: PropTypes.string,
}

export default SliderVideo
